import apiService from "./apiService";

export const getClinicsService = (query) => {
  let queryParams = {
    search: query?.business ?? "",
    page: query?.page ?? 1,
    item_per_page: 10,
  }
  return apiService.get(URIS.clinics, {params: queryParams})
}

export const setClinicStatusService = (payload) => {
  return apiService.patch(URIS_D("approve_documents", payload.id), {status: payload.status}
  )
}

export const getClinicInfoService = (clinicId) => {
  return apiService.get(URIS_D('clinicInfo', clinicId))
}


const URIS = {
  clinics: '/v1/admin/reports/clinics',
}

const URIS_D = (url, param1) => {
  return {
    approve_documents: `/businesses/${param1}`,
    clinicInfo: `/admin/clinics/${param1}`,
  }[url]
}



